
const API_URL = (
  process.env.REACT_APP_API_URL || ''
).replace(/\/+$/, '');

export async function listsApi(path, options = {}) {
  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error('Please log in first.');
  }

  if (!API_URL) {
    throw new Error('REACT_APP_API_URL is not configured.');
  }

  const { method = 'GET', body } = options;

  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      token,
      ...(body !== undefined
        ? { 'Content-Type': 'application/json' }
        : {})
    },
    ...(body !== undefined
      ? { body: JSON.stringify(body) }
      : {})
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(
      data?.error || `Request failed (${response.status})`
    );
  }

  return data;
}
